import { render, staticRenderFns } from "./ClientServiceReportDialog.vue?vue&type=template&id=673fe7a2&"
import script from "./ClientServiceReportDialog.vue?vue&type=script&lang=js&"
export * from "./ClientServiceReportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports